import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AppPageGroupModel } from 'app/models/shared/appPage.model';
import { WebsiteModel } from 'app/models/website-admin/website.model';
import { UserService } from 'app/services/user.service';
import { WebsiteService } from 'app/services/website.service';
import { Constants } from 'app/utility/constants';
import { timeout } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-menu-website-admin',
    templateUrl: './menu-website-admin.component.html',
    styleUrls: ['./menu-website-admin.component.scss'],
    standalone: false
})
export class MenuWebsiteAdminComponent implements OnInit
{
    public websites: WebsiteModel[] = [];
    public currentWebsite: WebsiteModel | undefined = undefined;
    public isNative: boolean = false;

    constructor(
        private websiteService: WebsiteService,
        private userService: UserService,
        private navCtrl: NavController,
    )
    {
    }

    loading: boolean = false;
    ngOnInit(): void
    {
        this.initialise();
    }

    async initialise()
    {
        this.loading = true;
        // console.log('MenuWebsiteAdminComponent: initialise');
        this.websiteService.getWebsites()
            .pipe(
                timeout(Constants.ApiDefaultTimeout)
            )
            .subscribe({
                next: (websites) =>
                {
                    // console.log(websites);
                    if (!websites || websites.length === 0)
                    {
                        this.userService.handleError('No websites found', false, false, false);
                        console.error('No websites found');
                        this.loading = false;
                        return;
                    }

                    this.websites = websites;
                    this.websites.forEach(site =>
                    {
                        site.websiteUrl = this.removeHttpProtocol(site.websiteUrl);
                        const exportSpecId = site.exportSpecId;
                        const urlPath = `website-admin/${exportSpecId}`;
                        if (window.location.pathname.includes(urlPath))
                        {
                            this.currentWebsite = site;
                        }
                    });
                    if (!this.currentWebsite && this.websites && this.websites.length)
                    {
                        this.currentWebsite = this.websites[0];
                    }

                    console.debug(`%ccurrentWebsite`, "color: green", this.currentWebsite);

                    this.setupPages();
                    this.loading = false;
                },
                error: (error) =>
                {
                    if (error.name === 'TimeoutError')
                    {
                        console.error('Request timed out');
                    } else
                    {
                        console.error('Error fetching websites:', error);
                    }
                    this.loading = false;
                    this.userService.handleError(error);
                }
            });
        this.isNative = Capacitor.isNativePlatform();
    }

    pageGroup: AppPageGroupModel | undefined = undefined;

    trackByFn(index, item)
    {
        return item.id; // unique id corresponding to the item
    }

    handleWebsiteChange(ev: any)
    {
        // see if we are on a page that is in this.pageGroup1 or this.pageGroup2
        // if so, replace currentWebsite.exportSpecId with website.exportSpecId within the current page url
        var website = this.websites.find(w => w.exportSpecId === ev.detail.value);
        this.currentWebsite = website;
        this.setupPages();

        if (website)
        {
            var newPath = window.location.pathname
                .replace(/website-admin\/([^\/]+)/, `website-admin/${website.exportSpecId}`)
                .replace(/(website-admin\/[^\/]+\/[^\/]+)\/.*/, '$1');
            const pageUrls = this.pageGroup.pages.map(p => p.url);
            if (!pageUrls.includes(newPath))
            {
                newPath = this.pageGroup.pages[0].url;
            }
            this.navCtrl.navigateRoot(newPath);
        }
    }

    handleWebsiteSelectClick(ev: Event)
    {
        ev.stopPropagation();
    }

    removeHttpProtocol(url: string): string
    {
        return url.replace(/^https?:\/\//, '');
    }

    setupPages()
    {
        var pageGroup: AppPageGroupModel =
        {
            area: 'website-admin',
            name: "",
            pages: []
        };

        if (!this.currentWebsite)
        {
            return;
        }

        var prefix = `/website-admin/${this.currentWebsite.exportSpecId}`;

        pageGroup.pages.push(
            {
                title: 'Vehicles',
                url: prefix + '/vehicles',
                icon: 'mc-vehicles'
            }
        );
        pageGroup.pages.push(
            {
                title: 'Dealerships',
                url: prefix + '/dealerships',
                icon: 'mc-dealerships'
            }
        );
        pageGroup.pages.push(
            {
                title: 'Products',
                url: prefix + '/products',
                icon: 'mc-products'
            }
        );
        pageGroup.pages.push(
            {
                type: 'divider',
            }
        );
        pageGroup.pages.push(
            {
                title: 'Blog',
                url: prefix + '/blog-entries',
                icon: 'mc-blog'
            }
        );
        pageGroup.pages.push(
            {
                title: 'Testimonials',
                url: prefix + '/testimonials',
                icon: 'mc-testimonials'
            }
        );
        // pageGroup.pages.push(
        //     {
        //         title: 'Custom content',
        //         url: prefix + '/custom-content',
        //         iconalt: 'icon-mc-vehicle'
        //     }
        // );
        this.pageGroup = pageGroup;
    }

    onSelectClick(event: Event)
    {
        event.stopPropagation();
    }
}
